module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":{"comments-for":"Comments for {name}"}},"es":{"heading":{"comments-for":"Comentarios para {name}"}}}')
  delete Component.options._Ctor
}
